export default "__VITE_ASSET__BLhCfxZd__"